import PoleCreateUpdateFormPresenter from "../../../../features/planBT/components/Pole/PoleCreateUpdateForm/PoleCreateUpdateFormPresenter";
import HeaderWidget from "../../../../common/components/molecule/HeaderWidget/HeaderWidget";
import { useMicroNavigator } from "../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import SinglePole from "../../../../features/planBT/components/Pole/SinglePole";

export default function EditPolePage() {
  const { navigate } = useMicroNavigator();
  return (
    <div style={{ color: "white" }}>
      <HeaderWidget
        withBackBtn
        handleBackBtn={() => navigate("list")}
        variant="dark"
      >
        Modifier <SinglePole.Name />
      </HeaderWidget>
      <PoleCreateUpdateFormPresenter isUpdate variant="dark" />
    </div>
  );
}
